import React from 'react'
import './testimonials.css'
// import AG from '../../assets/ag.jpg'
// import BEN from '../assets/ben.png'
// import OUS from '../../assets/ous.png'
// import MOH from '../../assets/moh.png'
import MOH from '../assets/moh.png';
import OUS from '../assets/Ous.jpg';
import BEN from '../assets/ben.png';
import AG from '../assets/ag.jpg';
import TEAM1 from '../assets/team-1.jpg';
import TEAM2 from '../assets/team-2.jpg';
import TEAM3 from '../assets/team-3.jpg';
import TEAM4 from '../assets/team-4.jpg';

// import Swiper core and required modules
import { Pagination } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const data = [
  {
    avatar: TEAM1,
    name: "Francis Brown",
    review: "Working with Ousmane was an absolute pleasure. Their expertise in web development and data analysis was evident from the start. They delivered a sleek and functional website that perfectly reflected our brand. Their adaptability and proficiency in cloud computing and DevOps made the entire process seamless. I highly recommend Ousmane for any technology solution"
  },
  {
    avatar: TEAM2,
    name: "Xiong Wang",
    review: "I am beyond impressed by the professionalism and dedication of Ousmane. Their knowledge of machine learning and cloud computing is unmatched. They transformed our raw data into actionable insights, elevating our business to new heights. Their commitment to delivering top-notch technological solutions is truly commendable"
  },
  {
    avatar: TEAM3,
    name: "John Larson",
    review: "I am thrilled with the website developed by Ousmane. Their proficiency in technology solutions and machine learning surpassed all my expectations. The website not only looks stunning but also performs flawlessly. Their mastery in cloud computing and DevOps ensured a smooth deployment process. I wholeheartedly recommend Ousmane for any technological endeavor."
  },
  {
    avatar: TEAM4,
    name: "Kenneth Yaounde",
    review: "Working with Ousmane was an absolute game-changer for our business. Their technological solutions, including website development, data analysis, and cloud computing, brought unparalleled efficiency to our operations. Their in-depth understanding of machine learning added significant value to our projects. I am continuously impressed by Ousmane's commitment to excellence."
  },
  {
    avatar: BEN,
    name: 'Benjamin',
    review: "Ousmane has been a great help to our development team, he joined as a freelancer and the team progress has been going fine since then" 
  },
  {
    avatar: MOH,
    name: 'Mohammed',
    review: "The website was amazing thank you Ousmane I will get back to you soon."
  },
  {
    avatar: AG,
    name: 'Atalib',
    review: "Ousmane did not create an app or web for me but we are partner of coding we have been creating apps and websites for clients."
  }
];

const Testimonial = () => {
  return (
    <section id='testimonial'>
      <h5>What clients said</h5>
      <h2>Testimonial</h2>

      <Swiper className='container testimonials__container'
       // install Swiper modules
       modules={[ Pagination]}
       spaceBetween={40}
       slidesPerView={1}
       pagination={{ clickable: true }}
       >
        {
          data.map(({avatar, name, review}, index) => {
            return (
            <SwiperSlide key={index} className='testimonial'>
              <div className="client__avatar">
                <img src={avatar} />
              </div>
                <h5 className='client__name'>{name}</h5>
                <small className='client__review'>
                  {review}
                </small>
            </SwiperSlide>
            )
          })
        }
      </Swiper>

    </section>
  )
}

export default Testimonial;